import { useEffect, useState } from "react";
import { wireCounter } from "../lib/ipfs";

/** Target equivalent bitrate for the YouTube comparison. 6 Mbps = 1080p talking-head. */
export const TARGET_BITRATE_BPS = 6_000_000;

function fmtBytes(n: number): string {
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} KB`;
  if (n < 1024 * 1024 * 1024) return `${(n / 1024 / 1024).toFixed(2)} MB`;
  return `${(n / 1024 / 1024 / 1024).toFixed(3)} GB`;
}

interface Props {
  /** Current playback time in seconds. Used to compute the YouTube-equivalent number. */
  playbackSeconds: number;
}

export default function BandwidthHUD({ playbackSeconds }: Props) {
  const [bytes, setBytes] = useState(0);
  useEffect(() => wireCounter.subscribe(setBytes), []);

  const youtubeEquivBytes = (playbackSeconds * TARGET_BITRATE_BPS) / 8;
  const ratio = bytes > 0 ? youtubeEquivBytes / bytes : 0;

  return (
    <div className="grid grid-cols-2 gap-4 font-mono">
      <div className="border border-white/20 rounded p-4">
        <div className="text-xs uppercase tracking-widest opacity-60">bytes off wire</div>
        <div className="text-3xl mt-2">{fmtBytes(bytes)}</div>
      </div>
      <div className="border border-white/20 rounded p-4">
        <div className="text-xs uppercase tracking-widest opacity-60">youtube equiv (6 Mbps)</div>
        <div className="text-3xl mt-2">{fmtBytes(youtubeEquivBytes)}</div>
        {ratio > 0 && (
          <div className="text-sm mt-1 opacity-70">{ratio.toFixed(2)}x heavier</div>
        )}
      </div>
    </div>
  );
}
